import { Controller } from "@hotwired/stimulus"

// Polls a URL and reloads the page when the response indicates ready
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 3000 }
  }

  connect() {
    this.stopped = false
    this.startPolling()
  }

  disconnect() {
    this.stopped = true
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }

  startPolling() {
    // Start polling after initial delay
    this.scheduleNextPoll()
  }

  scheduleNextPoll() {
    if (this.stopped) return

    this.timeout = setTimeout(() => {
      this.checkStatus()
    }, this.intervalValue)
  }

  async checkStatus() {
    if (this.stopped) return

    try {
      const response = await fetch(this.urlValue, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) {
        this.scheduleNextPoll()
        return
      }

      const data = await response.json()

      if (data.ready) {
        // Resource is ready - reload page
        this.stopped = true

        // Use Turbo if available, otherwise standard reload
        if (window.Turbo) {
          window.Turbo.visit(window.location.href, { action: "replace" })
        } else {
          window.location.reload()
        }
        return
      }

      // Not ready yet, continue polling
      this.scheduleNextPoll()
    } catch (error) {
      console.error("[poll-refresh] Error:", error)
      // Continue polling on error
      this.scheduleNextPoll()
    }
  }
}
